<template>
  <div class="lawofffastlaw">
    <div class="d1 flex_start">
      <subTitle text="快捷找律所" />
    </div>
    <div class="between mt30">
      <el-select
        :popper-append-to-body="false"
        v-model="value"
        placeholder="安徽"
        class="sele1"
		@change="changeprov"
      >
        <el-option
          v-for="(item,index) in provincecity"
          :key="item.id"
          :label="item.name"
          :value="index"
        >
        </el-option>
      </el-select>
      <div class="fgl"></div>
      <el-select
        v-model="value1"
        :popper-append-to-body="false"
        placeholder="合肥"
        class="sele1"
      >
        <el-option
          v-for="item in provincecity[theindex].children"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </div>
    <div class="between mt20">
      <el-select
        :popper-append-to-body="false"
        v-model="value2"
        placeholder="请选择专长"
        class="sele2"
      >
        <el-option
          v-for="item in majors"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </div>
    <div class="kscz" @click="tooffice">搜索</div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data() {
    return {
	  provincecity:[],
	  majors:[],
	  theindex:0,
      value: "北京",
	  value1: "北京",
	  value2: "",
    };
  },
 // computed:{
	// value2:(()=>{
	// 	return this.majors[0].name
	// }) 
 // },
  created() {
	  // alert(this.$route.params.test)
  	this.$http.home.provincecity().then(res =>{
		this.provincecity = res.data
		this.value = this.provincecity[0].name
		this.value1 = this.provincecity[0].children[0].name
	})
	this.$http.home.majors().then(res =>{
		this.majors = res.data
		this.value2 = this.majors[0].name
	})
  },
  methods:{
	  changeprov(e){
		  this.theindex = e
		  console.log(e)
	  },
	  tooffice(){
		  this.$router.push({
			  name:'seafirms',
			  params:{
				 test:123 
			  }
		  })
	  }
  }
};
</script>

<style lang="scss" scoped>
.lawofffastlaw {
  width: 100%;
  padding: 23px 12px 30px;

  .t1 {
    margin-top: 18px;
    margin-bottom: 10px;
    font-size: 14px;
    color: #666666;
  }
  .fgl {
    width: 15px;
    height: 1px;
    background: #dcdfe6;
    text-align: center;
  }
  .sele1 {
    width: 134px;
    height: 40px;
  }
  .sele2 {
    width: 100%;
    height: 40px;
  }
  .kscz {
    cursor: pointer;
    margin-top: 20px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #0465ea;
    border-radius: 5px;
  }
}
</style>